import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import LoginPage from '../../pages/LoginPage';

function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) return null;
  if (!isAuthenticated) return <LoginPage />;

  return <Outlet />;
}

export default ProtectedRoute;
